import KhoaThi from '../pages/KhoaThi'
import Permission from '../pages/Permission'
import Role from '../pages/Role'
import MonThi from '../pages/MonThi'
import HinhThucDaoTao from '../pages/HinhThucDaoTao'
import HeDaoTao from '../pages/HeDaoTao'
import User from '../pages/User'
import Nam from '../pages/Nam'
import Truong from '../pages/Truong'
import CauHinhBanChinh from '../pages/CauHinhBanChinh/CauHinhBanChinh'
import ImportVanBang from '../pages/VanBangBanChinh/ImportVanBang/ImportVanBang'
import ChoDuyet from '../pages/VanBangBanChinh/DuyetVanBang/ChoDuyet'
import ChuaDuyet from '../pages/VanBangBanChinh/DuyetVanBang/ChuaDuyet'
import VanBangDaDuyet from '../pages/VanBangBanChinh/VanBangDaDuyet'
import DieuChinhVanBang from '../pages/VanBangBanChinh/DieuChinhVanBang/DieuChinhVanBang'
import VanBangChuaDuyet from '../pages/VanBangBanChinh/DieuChinhVanBang/VanBangChuaDuyet'
import VanBangChoDuyet from '../pages/VanBangBanChinh/DieuChinhVanBang/VanBangChoDuyet'
import LischSuDieuChinhVanBang from '../pages/VanBangBanChinh/DieuChinhVanBang/LichSuDieuChinhVanBang'
import DieuChinhDaDuyet from '../pages/VanBangBanChinh/DieuChinhVanBang/DieuChinhDaDuyet'
import TraCuu from '../pages/VanBangBanChinh/TraCuu/TraCuu'
import ThietLapThamSo from '../pages/VanBangBanSao/ThietLapThamSo'
import TaoMoiVanBangBanSao from '../pages/VanBangBanSao/TaoMoiVanBangBanSao'
import VanBangBanSaoChuaDuyet from '../pages/VanBangBanSao/VanBangBanSaoChuaDuyet'
import VanBangBanSaoDaDuyet from '../pages/VanBangBanSao/VanBangBanSaoDaDuyet'
import LichSuCapPhat from '../pages/LichSuCapPhat'
import ChungNhanTotNghiepTamThoi from '../pages/ChungNhanTotNghiepTamThoi/ChungNhanTotNghiepTamThoi'
import Home from '../pages/Home'
import CapPhat from '../pages/VanBangBanChinh/CapPhat'
import TuHuy from '../pages/TuHuy'
import BanGiaoVanBangTongHop from '../pages/Report/BanGiaoVanBangTongHop'
import BanGiaoVanBangChiTiet from '../pages/Report/BanGiaoVanBangChiTiet'

const routes = [
  {
    path: '/',
    exact: true,
    requireLogin: true,
    component: <Home />,
  },
  {
    path: '/user',
    exact: true,
    requireLogin: true,
    parentName: 'Quản trị hệ thống',
    name: 'Quản trị người dùng',
    component: <User requirePermission="User" />,
  },
  {
    path: '/permission',
    exact: true,
    requireLogin: true,
    parentName: 'Quản trị hệ thống',
    name: 'Quản trị chức năng',
    component: <Permission requirePermission="Permission" />,
  },
  {
    path: '/role',
    exact: true,
    requireLogin: true,
    parentName: 'Quản trị hệ thống',
    name: 'Quản trị quyền',
    component: <Role requirePermission="Role" />,
  },
  {
    path: '/truongHoc',
    exact: true,
    requireLogin: true,
    parentName: 'Quản trị hệ thống',
    name: 'Quản trị trường',
    component: <Truong requirePermission="TruongHoc" />,
  },
  {
    path: '/heDaoTao',
    exact: true,
    requireLogin: true,
    parentName: 'Danh mục',
    name: 'Hệ đào tạo',
    component: <HeDaoTao requirePermission="HeDaoTao" />,
  },
  {
    path: '/hinhThucDaoTao',
    exact: true,
    requireLogin: true,
    parentName: 'Danh mục',
    name: 'Hình thức đào tạo',
    component: <HinhThucDaoTao requirePermission="HinhThucDaoTao" />,
  },
  {
    path: '/monThi',
    exact: true,
    requireLogin: true,
    parentName: 'Danh mục',
    name: 'Môn thi',
    component: <MonThi requirePermission="MonThi" />,
  },
  {
    path: '/nam',
    exact: true,
    requireLogin: true,
    parentName: 'Danh mục',
    name: 'Năm',
    component: <Nam requirePermission="Nam" />,
  },
  {
    path: '/khoaThi',
    exact: true,
    requireLogin: true,
    parentName: 'Danh mục',
    name: 'Khoá thi',
    component: <KhoaThi requirePermission="KhoaThi" />,
  },
  {
    path: '/cauHinhBanChinh',
    exact: true,
    requireLogin: true,
    parentName: 'Quản trị hệ thống',
    name: 'Cấu hình bản chính',
    component: <CauHinhBanChinh requirePermission="CauHinhBanChinh" />,
  },
  {
    path: '/import',
    exact: true,
    requireLogin: true,
    parentName: 'Văn bằng bản chính',
    name: 'Import',
    component: <ImportVanBang requirePermission="ImportVanBang" />,
  },
  {
    path: '/chuaDuyet',
    exact: true,
    requireLogin: true,
    parentName: 'Văn bằng bản chính',
    name: 'Chưa duyệt',
    component: <ChuaDuyet requirePermission="ChuaDuyet" />,
  },
  {
    path: '/choDuyet',
    exact: true,
    requireLogin: true,
    parentName: 'Văn bằng bản chính',
    name: 'Chờ duyệt',
    component: <ChoDuyet requirePermission="ChoDuyet" />,
  },
  {
    path: '/vanBangDaDuyet',
    exact: true,
    requireLogin: true,
    parentName: 'Văn bằng bản chính',
    name: 'Đã duyệt',
    component: <VanBangDaDuyet requirePermission="DaDuyet" />,
  },
  {
    path: '/dieuChinhVB',
    exact: true,
    requireLogin: true,
    parentName: 'Danh sách chỉnh sửa',
    name: 'Điều chỉnh',
    component: <DieuChinhVanBang requirePermission="DieuChinhVB" />,
  },
  {
    path: '/chuaDuyetVB',
    exact: true,
    requireLogin: true,
    parentName: 'Danh sách chỉnh sửa',
    name: 'Chưa duyệt',
    component: <VanBangChuaDuyet requirePermission="DieuChinhVB" />,
  },
  {
    path: '/daDuyetVB',
    exact: true,
    requireLogin: true,
    parentName: 'Danh sách chỉnh sửa',
    name: 'Đã duyệt',
    component: <DieuChinhDaDuyet requirePermission="DaDuyetVB" />,
  },
  {
    path: '/choDuyetVB',
    exact: true,
    requireLogin: true,
    parentName: 'Danh sách chỉnh sửa',
    name: 'Chờ duyệt',
    component: <VanBangChoDuyet requirePermission="ChoDuyetVB" />,
  },
  {
    path: '/lichSuDieuChinhVB',
    exact: true,
    requireLogin: true,
    parentName: 'Danh sách chỉnh sửa',
    name: 'Lịch sử',
    component: <LischSuDieuChinhVanBang requirePermission="LichSuDieuChinhVB" />,
  },
  {
    path: '/traCuu',
    exact: true,
    requireLogin: true,
    parentName: 'Văn bằng bản chính',
    name: 'Tra cứu',
    component: <TraCuu requirePermission="TraCuu" />,
  },
  {
    path: '/thietLapThamSoVanBangBanSao',
    exact: true,
    requireLogin: true,
    parentName: 'Văn bằng bản sao',
    name: 'Thiết lập tham số',
    component: <ThietLapThamSo requirePermission="ThietLapThamSoVanBangBanSao" />,
  },
  {
    path: '/taoMoiVanBangBanSao',
    exact: true,
    requireLogin: true,
    parentName: 'Văn bằng bản sao',
    name: 'Tạo mới',
    component: <TaoMoiVanBangBanSao requirePermission="TaoMoiVanBangBanSao" />,
  },
  {
    path: '/vanBangBanSaoChuaDuyet',
    exact: true,
    requireLogin: true,
    parentName: 'Văn bằng bản sao',
    name: 'Chưa duyệt',
    component: <VanBangBanSaoChuaDuyet requirePermission="VanBangBanSaoChuaDuyet" />,
  },
  {
    path: '/vanBangBanSaoDaDuyet',
    exact: true,
    requireLogin: true,
    parentName: 'Văn bằng bản sao',
    name: 'Đã duyệt',
    component: <VanBangBanSaoDaDuyet requirePermission="VanBangBanSaoDaDuyet" />,
  },
  {
    path: '/lichSuCapPhatBanSao',
    exact: true,
    requireLogin: true,
    parentName: 'Báo cáo',
    name: 'Lịch sử cấp phát',
    component: <LichSuCapPhat requirePermission="LichSuCapPhatBanSao" />,
  },
  {
    path: '/chungNhanTotNghiepDanhSach',
    exact: true,
    requireLogin: true,
    parentName: 'Chứng nhận tốt nghiệp',
    name: 'Chứng nhận tốt nghiệp tạm thời',
    component: <ChungNhanTotNghiepTamThoi requirePermission="ChungNhanTotNghiepDanhSach" />,
  },
  {
    path: '/capPhat',
    exact: true,
    requireLogin: true,
    parentName: 'Văn bằng bản chính',
    name: 'Cấp phát',
    component: <CapPhat requirePermission="" />,
  },
  {
    path: '/tuHuy',
    exact: true,
    requireLogin: true,
    parentName: 'Quản trị hệ thống',
    name: 'Xoá dữ liệu',
    component: <TuHuy requirePermission="TuHuy" />,
  },
  {
    path: '/banGiaoVanBangTongHop',
    exact: true,
    requireLogin: true,
    parentName: 'Báo cáo',
    name: 'Bàn giao văn bằng tổng hợp',
    component: <BanGiaoVanBangTongHop requirePermission="BanGiaoVanBangTongHop" />,
  },
  {
    path: '/banGiaoVanBangChiTiet',
    exact: true,
    requireLogin: true,
    parentName: 'Báo cáo',
    name: 'Bàn giao văn bằng chi tiết',
    component: <BanGiaoVanBangChiTiet requirePermission="BanGiaoVanBangChiTiet" />,
  },
]
export default routes
